module.exports = {
  'en': {
    'HRES6LUC1': {
      '0': '[HRES6LU] Approval of O.T Request',
      '10': '[HRES6LU] Approval of O.T Request',
      '20': 'No.',
      '30': 'Emp. ID.',
      '40': 'Name',
      '50': 'Req. Date',
      '60': 'Seq.No.',
      '70': 'O.T Period',
      '80': 'O.T. Time',
      '90': 'Before Work',
      '100': 'OT On Holiday',
      '110': 'After Work',
      '120': 'Reason ',
      '130': 'Status',
      '140': 'Code Appr.',
      '150': 'Appr. Date',
      '160': 'Remark',
      '170': 'Next Approve'
    },
    'HRES6LUC2': {
      '0': 'Detail of Approved',
      '10': 'For Employee',
      '20': 'Seq. App.',
      '30': 'Approved By',
      '40': 'Approved Date',
      '50': 'Current Status',
      '60': 'Status',
      '70': 'Approved',
      '80': 'Refused',
      '90': 'Remark',
      '100': 'No.of selected',
      '110': 'Record'
    },
    'HRES6LUC3': {
      '0': 'Detail of OT.',
      '10': 'Detail of OT.',
      '20': 'Emp. Name',
      '30': 'Between Date',
      '40': 'Date',
      '50': 'Type of day',
      '60': 'Type of O.T',
      '70': 'O.T Time in-out(Date,Time)',
      '80': 'From - To'
    },
    'HRES6LUC4': {
      '0': 'Actual Time Attendance',
      '10': 'Actual Time Attendance',
      '20': 'Employee Name',
      '30': 'Date',
      '40': 'Day',
      '50': 'Shift',
      '60': 'Schedule Time',
      '70': 'Time In',
      '80': 'Time Out'
    },
    'HRES6LUC5': {
      '0': 'Detail of Request',
      '10': 'Detail of Request',
      '20': 'Emp.Code',
      '30': 'Date Req.',
      '40': 'O.T. Period',
      '50': 'Form Date',
      '60': 'To',
      '70': 'O.T. Time',
      '80': 'Before Work',
      '90': 'OT On Holiday',
      '100': 'After Work',
      '110': 'Reason of request',
      '120': 'Remark',
      '130': 'Update By'
    }
  },
  'th': {
    'HRES6LUC1': {
      '0': '[HRES6LU] อนุมัติการขอ O.T',
      '10': '[HRES6LU] อนุมัติการขอ O.T',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่ขอ',
      '60': 'ลำดับที่',
      '70': 'ช่วงวันที่ขอ O.T',
      '80': 'เวลาขอ O.T',
      '90': 'ก่อนเวลาทำงาน',
      '100': 'ทำงานวันหยุด',
      '110': 'หลังเวลาทำงาน',
      '120': 'สาเหตุการขอ',
      '130': 'สถานะ',
      '140': 'ผู้อนุมัติ',
      '150': 'วันที่อนุมัติ',
      '160': 'หมายเหตุการอนุมัติ',
      '170': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES6LUC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'ลำดับที่อนุมัติ',
      '30': 'รหัสผู้อนุมัติ',
      '40': 'วันที่อนุมัติ',
      '50': 'สถานะปัจจุบัน',
      '60': 'สถานะ',
      '70': 'อนุมัติ',
      '80': 'ไม่อนุมัติ',
      '90': 'หมายเหตุ',
      '100': 'รายการที่เลือกทั้งหมด',
      '110': 'รายการ'
    },
    'HRES6LUC3': {
      '0': 'ประวัติการทำงานล่วงเวลา',
      '10': 'ประวัติการทำงานล่วงเวลา',
      '20': 'ชื่อพนักงาน',
      '30': 'ระหว่างวันที่',
      '40': 'วันที่',
      '50': 'ประเภทวัน',
      '60': 'ประเภท OT',
      '70': 'ช่วงเวลาทำงานล่วงเวลา(วันที่ เวลา)',
      '80': 'ตั้งแต่ - ถึง'
    },
    'HRES6LUC4': {
      '0': 'รายละเอียดเวลารูดบัตร',
      '10': 'รายละเอียดเวลารูดบัตร',
      '20': 'ชื่อพนักงาน',
      '30': 'วันที่',
      '40': 'วัน',
      '50': 'รหัสกะ',
      '60': 'เวลาปฏิบัติงาน',
      '70': 'เวลารูดบัตรเข้า',
      '80': 'เวลารูดบัตรออก'
    },
    'HRES6LUC5': {
      '0': 'รายละเอียดคำร้องขอทำงานล่วงเวลา',
      '10': 'รายละเอียดคำร้องขอทำงานล่วงเวลา',
      '20': 'รหัสพนักงาน',
      '30': 'วันที่ขอ',
      '40': 'ช่วงวันที่ขอ O.T.',
      '50': 'ตั้งแต่',
      '60': 'ถึง',
      '70': 'เวลาขอ O.T',
      '80': 'ก่อนเวลาทำงาน',
      '90': 'ทำงานวันหยุด',
      '100': 'หลังเวลาทำงาน',
      '110': 'สาเหตุการขอ',
      '120': 'รายละเอียด',
      '130': 'ผู้บันทึก'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres6lu.js